import { getUserConfig } from './userConfig';

export default function getSubscriptionStatus() {
    return getUserConfig()?.subscriptionStatus;
}
